/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Reverse_Ten_FramesInputs */



/**
* | output |
* | --- |
* | "Reverse 10 Frame" |
*
* @param {Shortcut_Keys_Name_Reverse_Ten_FramesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_reverse_ten_frames = /** @type {((inputs?: Shortcut_Keys_Name_Reverse_Ten_FramesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Reverse_Ten_FramesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reculer de 10 images")
	if (locale === "de") return /** @type {LocalizedString} */ ("Rückwärts-10-Rahmen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fotogramma inverso 10")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обратная сторона 10-кадровой рамки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Marco 10 inverso")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("反向10帧")
	if (locale === "ja") return /** @type {LocalizedString} */ ("リバース10フレーム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिवर्स 10 फ्रेम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Quadro reverso 10")
	return /** @type {LocalizedString} */ ("Reverse 10 Frame")
});